import withStyles from 'react-jss'
// used for styles only
export default ({ styles } = {}) => withStyles(styles, { injectTheme: false })